export default __webpack_public_path__ + "1e4c795d148008c01dc11631ecf5a2bc.png";